import { callApiDirectly } from './Request'

const apiAcuity = {

  /**
   * Appointment Types
   * @returns {void} .
   */
  appointmentTypes() {
    return callApiDirectly(
      `${process.env.REACT_APP_ACUITY_API_GATEWAY}appointment-types`,
      {
        method: 'GET',
      }
    )
  },

  /**
   * Calendars
   * @returns {void} .
   */
  calendars() {
    return callApiDirectly(`${process.env.REACT_APP_ACUITY_API_GATEWAY}calendars`, {
      method: 'GET',
    })
  },

  /**
   * Dates
   * @param {String} typeId .
   * @param {String} month .
   * @param {String} calendarId .
   * @returns {void} .
   */
  dates(typeId, month, calendarId) {
    return callApiDirectly(
      `${process.env.REACT_APP_ACUITY_API_GATEWAY
      }dates/${typeId}/${month}/${calendarId}`,
      {
        method: 'GET',
      }
    )
  },

  /**
   * Times
   * @param {String} typeId .
   * @param {String} date .
   * @param {String} calendarId .
   * @returns {void} .
   */
  times(typeId, date, calendarId) {
    return callApiDirectly(
      `${process.env.REACT_APP_ACUITY_API_GATEWAY
      }times/${typeId}/${date}/${calendarId}`,
      {
        method: 'GET',
      }
    )
  },

  /**
   * Cancel Appointment
   * @param {String} id .
   * @returns {void} .
   */
  cancel(id) {
    return callApiDirectly(
      `${process.env.REACT_APP_ACUITY_API_GATEWAY
      }appointment/cancel/${id}`,
      {
        method: 'GET',
      }
    )
  },

  /**
   * Appointments
   * @param {String} datetime .
   * @param {String} appointmentTypeID .
   * @param {Object} userData .
   * @param {String} userData.firstName .
   * @param {String} userData.email .
   * @param {String} userData.phone .
   * @param {String} userData.lastName .
   * @param {String} customerId .
   * @returns {void} .
   */
  appointments(datetime, appointmentTypeID, userData, customerId) {
    return callApiDirectly(`${process.env.REACT_APP_ACUITY_API_GATEWAY}appointments`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        datetime,
        appointmentTypeID,
        ...userData,
        fields: [
          {
            id: 7922320,
            value: customerId
          },
          {
            id: 7922058,
            value: 'retail'
          }
        ]
      }),
    })
  },
}

export default apiAcuity
